export const 
    INITIAL_STATE = {
        hasError: false,
        title: '',
        message: ''
    };


// WEBPACK FOOTER //
// ./src/reducers/state/Error.js